import { z } from 'zod';
import { ulidSchema } from './id';
import { publicProfileSchema } from './user';

// `boards.voting_permission`, `ck_boards_voting_permission`.
export const VOTING_PERMISSIONS = [
  'disabled',
  'members',
  'members_and_observers',
  'workspace_members',
] as const;

export const votingPermissionSchema = z.enum(VOTING_PERMISSIONS);

export type VotingPermission = z.infer<typeof votingPermissionSchema>;

// Field-scoped board voting setting patches - SC-4.
export const boardVotingEnabledPatchSchema = z.strictObject({
  votingEnabled: z.boolean(),
});

export type BoardVotingEnabledPatch = z.infer<typeof boardVotingEnabledPatchSchema>;

export const boardVotingPermissionPatchSchema = z.strictObject({
  votingPermission: votingPermissionSchema,
});

export type BoardVotingPermissionPatch = z.infer<typeof boardVotingPermissionPatchSchema>;

export const boardVotingHideTalliesPatchSchema = z.strictObject({
  votingHideTallies: z.boolean(),
});

export type BoardVotingHideTalliesPatch = z.infer<
  typeof boardVotingHideTalliesPatchSchema
>;

// Companion responses, one per board voting setting.
export const boardVotingEnabledSchema = z.object({
  boardId: ulidSchema,
  votingEnabled: z.boolean(),
});

export type BoardVotingEnabled = z.infer<typeof boardVotingEnabledSchema>;

export const boardVotingPermissionSchema = z.object({
  boardId: ulidSchema,
  votingPermission: votingPermissionSchema,
});

export type BoardVotingPermission = z.infer<typeof boardVotingPermissionSchema>;

export const boardVotingHideTalliesSchema = z.object({
  boardId: ulidSchema,
  votingHideTallies: z.boolean(),
});

export type BoardVotingHideTallies = z.infer<typeof boardVotingHideTalliesSchema>;

const voteCountSchema = z.number().int().nonnegative().nullable();

export const cardVoteStateSchema = z.object({
  cardId: ulidSchema,
  voted: z.boolean(),
  mayVote: z.boolean(),
  voteCount: voteCountSchema,
  talliesHidden: z.boolean(),
  votingEnabled: z.boolean(),
});

export type CardVoteState = z.infer<typeof cardVoteStateSchema>;

export const cardVoteTallySchema = z.object({
  cardId: ulidSchema,
  voteCount: voteCountSchema,
  voters: z.array(publicProfileSchema),
});

export type CardVoteTally = z.infer<typeof cardVoteTallySchema>;
